// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats__1xesD","card":"Stats_card__3Dxqh"};